module.exports = __webpack_public_path__ + "img/tf2_killstreakkit_specialized.27bffdb5.png";